import React from 'react';
import UserLayout from '../../components/Layout/UserLayout';
import TrustAndVerification from './TrustAndVerification';
import { emailVerification } from '../../actions/manageUserVerification';
import { getp } from '../../helpers/getProp';
import VerifiedThanks from './VerifiedThanks';
import mobileInfo from '../../mobileInfo';

const title = 'Trust and Verification';

export default {
  path: '/user/verification/:confirm?/:email?/:bla?',

  action({ store, query, params }) {
    // From Redux Store
    // let isAuthenticated = store.getState().runtime.isAuthenticated;

    // if (!isAuthenticated) {
    //   if ('confirm' in query && 'email' in query) {
    //     return { redirect: '/login?verification=email' };
    //   }
    //   return { redirect: '/login' };
    // }

    const userId = getp(store.getState(), 'account.data.userId');
    console.log('params', params)
    if (params.confirm) {
      store.dispatch(
        emailVerification(params.confirm, params.email.replace(' ', '+'), userId),
      );
    }

    let isMobile;
    let mi;
    if (process.env.BROWSER) {
      mi = mobileInfo(window.navigator.userAgent);
      isMobile =
        (mi.os && mi.os.toLowerCase() === 'ios') ||
        (mi.os && mi.os.indexOf('ndroid') >= 0);
    }

    if (!userId) {
      return {
        title,
        component: (
          <UserLayout>
            <VerifiedThanks title={title} isMobile={isMobile} />
          </UserLayout>
        ),
      };
    }

    return {
      title,
      component: (
        <UserLayout>
          <TrustAndVerification title={title} />
        </UserLayout>
      ),
    };
  },
};



// WEBPACK FOOTER //
// ./src/routes/trustAndVerification/index.js